export enum TransferRequestStatusEnum {
    requested = 0,
    approved = 1,
    rejected = 2
}